import { AnyAction } from 'redux';
import { BUY_BUTTON_SET_ARTICLE_NUMBER } from '../constants';

export interface BuyButtonState {
  articleNumber?: string;
  disabled?: boolean;
  isLoading?: boolean;
}

const DEFAULT_STATE: BuyButtonState = {};

export const buyButton = (
  state = DEFAULT_STATE,
  action: AnyAction
): BuyButtonState => {
  switch (action.type) {
    case BUY_BUTTON_SET_ARTICLE_NUMBER:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
